export const replaceAll =
  (prefix: string | undefined = '') =>
  (string: string, [placeholder, value]: [string, string]): string =>
    string.replace(new RegExp(`${prefix}${placeholder}`, 'g'), value)
